import initialState from "reducers/initialState";
import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";

export default function documentEntitiesReducer(state = initialState.document.entities, action) {
  switch (action.type) {
    case actionTypes.LOAD_DOCUMENT_ENTITIES_STARTED: {
      const key = action.payload.key;
      return {
        ...state,
        [key]: {
          ...state[key],
          isLoaded: false,
          loading: true,
          data: []
        }
      };
    }

    case actionTypes.LOAD_DOCUMENT_ENTITIES_SUCCEEDED: {
      const key = action.payload.key;
      return {
        ...state,
        [key]: {
          ...state[key],
          data: action.payload.documentEntities,
          isLoaded: true,
          loading: false
        }
      };
    }

    case eventTypes.OFFER_ENTITIES_INVALIDATED: {
      const key = `${action.event.eventBody.documentId}-${action.event.eventBody.siteId}`;
      return {
        ...state,
        [key]: {
          ...state[key],
          isLoaded: false,
          loading: false
        }
      };
    }
    default:
      return state;
  }
}
